/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Kind of document:   * `AllInOne` - Single PDF document, which can be downloaded just before the final quote. german: Antragszusammenfassung (vor Abschluß), approx. 31 pages   * `Contract` - Single PDF document with all final contract data. german: Antragszusammenfassung (nach Abschluß), approx. 13 pages   * `ContractConditions` - Single PDF document with contract conditions. german: Versicherungsbedingungen, approx. 21 pages
 */
export const DocumentKind = {
  AllInOne: 'AllInOne',
  Contract: 'Contract',
  ContractConditions: 'ContractConditions',
} as const;
export type DocumentKind = (typeof DocumentKind)[keyof typeof DocumentKind];
